import { store } from "@redux"

const haveAuth = (accessNames = [], type) => {
  const { userAccountInfo: { accesses } } = store.getState()

  if (accesses.hasFullAccess) return true

  if (type === "needOneOfAccesses") {
    return accessNames.some(accessName =>
      !!accesses[accessName]
    )
  }

  if (type === "needMultipleAccesses") {
    return accessNames.every(accessName =>
      !!accesses[accessName]
    )
  }
  const accessName = accessNames[0]

  return !!accesses[accessName]
}

export default haveAuth